// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.explorer-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 50px);
}

.searchable-node-container {
    min-height: 65%;
}

.preview-container {
    max-height: 35%;
    overflow: auto;
}

.cytoscape-control-widget {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: var(--padding);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px 0 0 10px;
    background-color: transparent;
}

.cytoscape-container {
    position: relative;
    height: calc(100% - 50px);
    width: 100%;
    background-color: var(--sub-window-bg);
    padding: 5px;
}


.react-flow, .cytoscape-instance {
    width: 100%;
    height: calc(100% - 50px) !important
}

.cytoscape-control-widget input[type=range] {
    height: 30px;
}

.cytoscape-control-widget input[type=range]::-webkit-slider-thumb {
    height: 30px;
    width: 20px;
}


.react-flow__node-customNode {
    display: flex;
    height: 50px;
    justify-content: center;
    align-items: center;
    width: 180px;
    border-radius: var(--border-radius);
    cursor: pointer !important;
}

.react-flow__node-customNode .selected-node {
    outline: 2px solid var(--blue-stone);
}

.react-flow__node-customNode:hover:not(:has(button:hover)) {
    display: flex;
    height: 50px;
    justify-content: center;
    align-items: center;
    width: 180px;
    border-radius: var(--border-radius);
    background-color: var(--window-bg);
}

.react-flow__node-customNode button:hover {
    background-color: var(--window-bg) !important;
}


.react-flow__node-customNode svg {
    max-width: 25px;
    max-height: 25px;
}

.react-flow__node-customNode p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 120px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/sandbox/Explorer/searchableNodes.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,sCAAsC;IACtC,YAAY;AAChB;;;AAGA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,6CAA6C;AACjD;;;AAGA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB","sourcesContent":[".explorer-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: calc(100% - 50px);\r\n}\r\n\r\n.searchable-node-container {\r\n    min-height: 65%;\r\n}\r\n\r\n.preview-container {\r\n    max-height: 35%;\r\n    overflow: auto;\r\n}\r\n\r\n.cytoscape-control-widget {\r\n    position: absolute;\r\n    bottom: 0;\r\n    right: 0;\r\n    padding: var(--padding);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 10px 0 0 10px;\r\n    background-color: transparent;\r\n}\r\n\r\n.cytoscape-container {\r\n    position: relative;\r\n    height: calc(100% - 50px);\r\n    width: 100%;\r\n    background-color: var(--sub-window-bg);\r\n    padding: 5px;\r\n}\r\n\r\n\r\n.react-flow, .cytoscape-instance {\r\n    width: 100%;\r\n    height: calc(100% - 50px) !important\r\n}\r\n\r\n.cytoscape-control-widget input[type=range] {\r\n    height: 30px;\r\n}\r\n\r\n.cytoscape-control-widget input[type=range]::-webkit-slider-thumb {\r\n    height: 30px;\r\n    width: 20px;\r\n}\r\n\r\n\r\n.react-flow__node-customNode {\r\n    display: flex;\r\n    height: 50px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 180px;\r\n    border-radius: var(--border-radius);\r\n    cursor: pointer !important;\r\n}\r\n\r\n.react-flow__node-customNode .selected-node {\r\n    outline: 2px solid var(--blue-stone);\r\n}\r\n\r\n.react-flow__node-customNode:hover:not(:has(button:hover)) {\r\n    display: flex;\r\n    height: 50px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 180px;\r\n    border-radius: var(--border-radius);\r\n    background-color: var(--window-bg);\r\n}\r\n\r\n.react-flow__node-customNode button:hover {\r\n    background-color: var(--window-bg) !important;\r\n}\r\n\r\n\r\n.react-flow__node-customNode svg {\r\n    max-width: 25px;\r\n    max-height: 25px;\r\n}\r\n\r\n.react-flow__node-customNode p {\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    width: 120px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
